<template>
  <div>
    <v-card height="100%" width="640px" max-height="125" align="center" color="grey lighten-4" elevation="0">
      <v-img v-if="item.file" :src="fileToUrl(item)" height="100%" max-height="125" contain @click="openDialog"></v-img>

      <v-btn
        v-if="item.isLoading || item.isUploaded"
        :loading="item.isLoading"
        dark
        fab
        small
        absolute
        top
        right
        elevation="0"
        class="topAdjusted overwriteDisbaled grey darken-4"
        @click="openDialog"
      >
        <v-icon v-if="item.isUploaded"> mdi-check </v-icon>
      </v-btn>
    </v-card>
    <confirm-action-dialog
      :isDialogActive.sync="dialog"
      :title="item && item.file && item.file.name ? item.file.name : ''"
      leftColor="error"
      :leftText="$t('delete')"
      :rightText="$t('ok')"
      @leftClick="deleteImage"
      @rightClick="dialog = false"
    >
      <v-img
        :style="`max-height: calc(100vh - ${$vuetify.breakpoint.smAndDown ? '225px' : '300px'});`"
        class="align-end ma-auto"
        contain
        :src="dialogImage"
        @click="dialog = false"
      />
    </confirm-action-dialog>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { IImageUploaded } from "@/models/Image/IImageUploaded";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";

@Component({ components: { ConfirmActionDialog } })
export default class FileUpload extends Vue {
  @Prop()
  public item!: IImageUploaded;

  dialogImage = "";
  dialog = false;

  fileToUrl(imageUploaded: IImageUploaded) {
    return URL.createObjectURL(imageUploaded.file);
  }

  openDialog() {
    this.dialog = true;
    this.dialogImage = this.fileToUrl(this.item);
  }

  deleteImage() {
    this.$emit("deleted", this.item.file);
    this.dialog = false;
    this.dialogImage = "";
  }
}
</script>

<style scoped></style>
